<template>
  <div class="flex flex-col gap-2">
    <span>{{ $i18nPresenter.t('Response') }}</span>
    <span class="font-bold">
      {{ submissions }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    dataAnswer: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    submissions() {
      return this.dataAnswer?.response.submissions?.map((item) => item.text).join(', ')
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
